/* PDP Related Products JS */

;(function () {
  function getMainProductJson() {
    var el = document.querySelector('[data-main-product]');
    if (!el) return null;
    try {
      return JSON.parse(el.getAttribute('data-main-product'));
    } catch (e) {
      return null;
    }
  }

  function getSelectedVariantId() {
    var urlParams = new URLSearchParams(window.location.search);
    var fromUrl = urlParams.get('variant');
    if (fromUrl) return String(fromUrl);

    var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput && idInput.value) return String(idInput.value);

    return null;
  }

  function getCurrentVariantTitle() {
    var product = getMainProductJson();
    if (!product || !Array.isArray(product.variants)) return null;

    var vid = getSelectedVariantId();
    if (vid) {
      var found = product.variants.find(function (v) { return String(v.id) === String(vid); });
      if (found && found.title) return String(found.title);
    }

    // Fallback to first available
    if (product.variants[0] && product.variants[0].title) {
      return String(product.variants[0].title);
    }
    return null;
  }

  function setActiveVariantByTitle(variantTitle) {
    if (!variantTitle) return;
    var containers = document.querySelectorAll('pdp-related-products .pdp-related-products--item');
    var normalized = String(variantTitle).trim().toLowerCase();
    containers.forEach(function (container) {
      var inners = container.querySelectorAll('.pdp-related-products--item-inner');
      var match = null;
      inners.forEach(function (inner) {
        var label = String(inner.getAttribute('data-related-product-variant-label') || '')
          .trim()
          .toLowerCase();
        if (!match && label === normalized) match = inner;
      });
      if (match) {
        inners.forEach(function (inner) { inner.classList.remove('active-variant'); });
        match.classList.add('active-variant');
      }
      // If no match, keep existing default active-variant as-is
    });
  }

  function handleVariantChangeFromDom() {
    setActiveVariantByTitle(getCurrentVariantTitle());
  }

  function bindListeners() {
    document.addEventListener('variant:changed', function (e) {
      var title = e && e.detail && e.detail.variant && e.detail.variant.title;
      if (title) setActiveVariantByTitle(String(title)); else handleVariantChangeFromDom();
    });

    document.addEventListener('product:variant-change', function (e) {
      var title = e && e.detail && e.detail.variant && e.detail.variant.title;
      if (title) setActiveVariantByTitle(String(title)); else handleVariantChangeFromDom();
    });

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target) return;
      if (target.matches('form[action*="/cart/add"] [name="id"]')) {
        handleVariantChangeFromDom();
      }
    });

    window.addEventListener('popstate', handleVariantChangeFromDom);
  }

  function init() {
    if (!document.querySelector('pdp-related-products')) return;
    bindListeners();
    // Initial sync on load
    handleVariantChangeFromDom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


